// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.process-section {
  position: relative;
  scroll-margin-top: 4.5rem;
  background: var(--bg-surface);
  border-bottom: 1px solid var(--border-subtle);
}

.process-section__inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 4.5rem 1.25rem;
}

.process-section__intro {
  text-align: center;
  max-width: 56ch;
  margin: 0 auto 3.5rem;
}

.process-section__eyebrow {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: var(--interactive-hover);
  margin-bottom: 0.75rem;
}

.process-section__title {
  font-size: clamp(1.5rem, 3vw, 2.1rem);
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.6rem;
}

.process-section__subtitle {
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: 1.6;
}

/* ---------- Steps timeline ---------- */

.process-steps {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  counter-reset: process-step;
}

.process-step {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 0.5rem;
}

/* Connecting line runs through the icon markers, between step 1 and step 4 */
.process-step:not(:last-child)::after {
  content: '';
  position: absolute;
  top: 2.25rem;
  left: calc(50% + 2.25rem);
  width: calc(100% - 2.5rem);
  height: 2px;
  background: var(--border-subtle);
}

.process-step__marker {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4.5rem;
  height: 4.5rem;
  border-radius: var(--radius-pill);
  background: var(--brand-primary);
  color: var(--interactive);
  border: 2px solid var(--interactive);
  margin-bottom: 1.25rem;
  z-index: 1;
}

.process-step__icon svg {
  width: 1.75rem;
  height: 1.75rem;
}

.process-step__number {
  position: absolute;
  top: -0.4rem;
  right: -0.4rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: var(--radius-pill);
  background: var(--interactive);
  color: var(--interactive-fg);
  font-size: 0.75rem;
  font-weight: 700;
}

.process-step__title {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.4rem;
}

.process-step__description {
  font-size: 0.9rem;
  color: var(--text-secondary);
  line-height: 1.55;
  max-width: 22ch;
}

/* ---------- CTA ---------- */

.process-section__cta {
  display: flex;
  justify-content: center;
  margin-top: 3.5rem;
}

/* ---------- Responsive ---------- */

@media (max-width: 900px) {
  .process-steps {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 3rem;
  }

  .process-step:not(:last-child)::after {
    display: none;
  }
}

@media (max-width: 560px) {
  .process-section__inner {
    padding: 3rem 1rem;
  }

  .process-section__intro {
    margin-bottom: 2.5rem;
  }

  .process-steps {
    grid-template-columns: 1fr;
    row-gap: 2.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/ProcessSection/ProcessSection.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA,yCAAyC;;AAEzC;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,6EAA6E;AAC7E;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,iCAAiC;EACjC,gCAAgC;EAChC,yBAAyB;EACzB,oCAAoC;EACpC,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;AACjB;;AAEA,8BAA8B;;AAE9B;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,qCAAqC;;AAErC;EACE;IACE,qCAAqC;IACrC,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,eAAe;EACjB;AACF","sourcesContent":[".process-section {\n  position: relative;\n  scroll-margin-top: 4.5rem;\n  background: var(--bg-surface);\n  border-bottom: 1px solid var(--border-subtle);\n}\n\n.process-section__inner {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 4.5rem 1.25rem;\n}\n\n.process-section__intro {\n  text-align: center;\n  max-width: 56ch;\n  margin: 0 auto 3.5rem;\n}\n\n.process-section__eyebrow {\n  display: inline-block;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.25em;\n  text-transform: uppercase;\n  color: var(--interactive-hover);\n  margin-bottom: 0.75rem;\n}\n\n.process-section__title {\n  font-size: clamp(1.5rem, 3vw, 2.1rem);\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 0.6rem;\n}\n\n.process-section__subtitle {\n  color: var(--text-secondary);\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n/* ---------- Steps timeline ---------- */\n\n.process-steps {\n  list-style: none;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 2rem;\n  counter-reset: process-step;\n}\n\n.process-step {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding-top: 0.5rem;\n}\n\n/* Connecting line runs through the icon markers, between step 1 and step 4 */\n.process-step:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  top: 2.25rem;\n  left: calc(50% + 2.25rem);\n  width: calc(100% - 2.5rem);\n  height: 2px;\n  background: var(--border-subtle);\n}\n\n.process-step__marker {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 4.5rem;\n  height: 4.5rem;\n  border-radius: var(--radius-pill);\n  background: var(--brand-primary);\n  color: var(--interactive);\n  border: 2px solid var(--interactive);\n  margin-bottom: 1.25rem;\n  z-index: 1;\n}\n\n.process-step__icon svg {\n  width: 1.75rem;\n  height: 1.75rem;\n}\n\n.process-step__number {\n  position: absolute;\n  top: -0.4rem;\n  right: -0.4rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: var(--radius-pill);\n  background: var(--interactive);\n  color: var(--interactive-fg);\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.process-step__title {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 0.4rem;\n}\n\n.process-step__description {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  line-height: 1.55;\n  max-width: 22ch;\n}\n\n/* ---------- CTA ---------- */\n\n.process-section__cta {\n  display: flex;\n  justify-content: center;\n  margin-top: 3.5rem;\n}\n\n/* ---------- Responsive ---------- */\n\n@media (max-width: 900px) {\n  .process-steps {\n    grid-template-columns: repeat(2, 1fr);\n    row-gap: 3rem;\n  }\n\n  .process-step:not(:last-child)::after {\n    display: none;\n  }\n}\n\n@media (max-width: 560px) {\n  .process-section__inner {\n    padding: 3rem 1rem;\n  }\n\n  .process-section__intro {\n    margin-bottom: 2.5rem;\n  }\n\n  .process-steps {\n    grid-template-columns: 1fr;\n    row-gap: 2.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
